export default {"src":"/_next/static/media/targetInCircle.a577ed46.svg","height":100,"width":100};